import React from 'react'
import classNames from 'classnames'
import css from './LoadingState.styles.scss'
import { ShimmerContainerProps, ShimmerProps } from './LoadingState.types'

const Shimmer: React.FC<ShimmerProps> = ({ className }) => (
  <div className={classNames(css.LoadingState__Shimmer, className)} />
)

const ShimmerContainer: React.FC<ShimmerContainerProps> = ({
  children,
  className,
  orientation,
}) => (
  <div
    className={classNames(css.LoadingState__ShimmerContainer, className, {
      [css.LoadingState__ShimmerContainer__Horizontal]:
        orientation === 'horizontal',
      [css.LoadingState__ShimmerContainer__Vertical]:
        orientation === 'vertical',
    })}
  >
    {children}
  </div>
)

const ShimmerItem: React.FC = () => (
  <ShimmerContainer className={css.LoadingState__Item} orientation="horizontal">
    <Shimmer className={css.LoadingState__Item__Image} />
    <ShimmerContainer orientation="vertical">
      <Shimmer className={css.LoadingState__Item__Title} />
      <Shimmer className={css.LoadingState__Item__Description} />
    </ShimmerContainer>
  </ShimmerContainer>
)

const DotSeparator: React.FC = () => (
  <div className={css.LoadingState__DotSeparator}>·</div>
)

const LoadingState: React.FC = () => (
  <div className={css.LoadingState} data-testid="GiftTrackerList__LoadingState">
    <ShimmerContainer
      className={css.LoadingState__MobileOnly}
      orientation="vertical"
    >
      <Shimmer className={css.LoadingState__Title} />
      <Shimmer className={css.LoadingState__Date} />
    </ShimmerContainer>
    <ShimmerContainer
      className={css.LoadingState__HiddenMobile}
      orientation="horizontal"
    >
      <Shimmer className={css.LoadingState__Date} />
      <DotSeparator />
      <Shimmer className={css.LoadingState__Date} />
    </ShimmerContainer>
    <ShimmerContainer
      className={css.LoadingState__Item__Container}
      orientation="vertical"
    >
      <ShimmerItem />
      <ShimmerItem />
    </ShimmerContainer>
  </div>
)

export default LoadingState
